import React from "react";
import { useEntitlements } from "../context/EntitlementsContext";
import DemoLock from "./DemoLock";

const Gated = ({ featureKey, children }) => {
  const { allow, loading } = useEntitlements();
  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center" data-testid="gated-loading">
        <div className="ws-live-dot" />
      </div>
    );
  }
  if (allow(featureKey)) return children;
  return <DemoLock featureKey={featureKey} />;
};

export default Gated;
